<template>
    <div id="services-empowering">
        <div class="illustration-wrapper">
            <div class="illustration-container">
                <img class="web-illustration" src="/images/elements/home/web/empowering-illustration.png"
                    alt="empowering-illustration" />
            </div>
        </div>
        <div class="content-container">
            <div class="content-inner">
                <div class="content-section">
                    <div class="title headline-l">{{ $t('ourServicesScreen.empowering.title') }}</div>
                    <div class="illustration-mobile-wrapper">
                        <img class="mobile-illustration" src="/images/elements/home/web/empowering-illustration.png"
                            alt="empowering-mobile-illustration" />
                    </div>
                    <div class="description text-l">
                        {{ $t('ourServicesScreen.empowering.description') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ServicesEmpowering',
    props: {},
    components: {},
    data: () => ({}),
    created() { },
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
#services-empowering {
    position: relative;
    height: auto;
    min-height: 483px;
    width: 100%;
    border-bottom: 1px solid #6464FF;

    @media (max-width: $breakpoint-md) {
        min-height: fit-content;
        padding: 60px 0;
    }

    .illustration-mobile-wrapper {
        justify-content: center;
        display: flex;
        margin-bottom: $margin-m;
        width: 100%;

        @media (min-width: $breakpoint-md) {
            display: none;
        }

        .mobile-illustration {
            width: 100%;
            max-width: 460px;
            height: auto;
            object-fit: cover;
        }
    }

    .illustration-wrapper {
        height: 100%;
        min-height: 483px;
        width: 100%;
        position: absolute;
        align-items: center;
        display: flex;

        @media (max-width: $breakpoint-md) {
            display: none;
        }

        .web-illustration {
            position: absolute;
            z-index: 1;
            left: 0;
            height: 483px;
            width: 611px;
            object-fit: cover;

            @media (max-width: $breakpoint-lg) {
                width: 400px;
            }
        }
    }

    .illustration-container {
        height: 100%;
        display: flex;
        align-items: center;
        position: relative;
        width: 100%;
    }

    .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-height: 483px;
        margin-left: 611px;
        padding-left: 123px;

        @media (max-width: $breakpoint-lg) {
            margin-left: 400px;
        }

        @media (max-width: $breakpoint-md) {
            margin-left: 0;
            padding-left: 0;
            min-height: auto;
        }

        .content-inner {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            z-index: 1;

            @media (max-width: $breakpoint-md) {
                align-items: center;
            }

            .content-section {
                padding-right: calc(((100vw - 1196px) / 2) + 15px);
                width: 100%;
                flex-direction: column;

                @media (max-width: $breakpoint-lg) {
                    padding-right: calc(((100vw - 960px) / 2) + 15px);
                }

                @media (max-width: $breakpoint-md) {
                    padding-right: 15px;
                    padding-left: 15px;
                    max-width: 720px;
                }

                @media (max-width: $breakpoint-sm) {
                    max-width: 540px;
                }

                @media (max-width: $breakpoint-xs) {
                    padding-left: 0px;
                    padding-right: 0px;
                }

                .title {
                    margin-bottom: 40px;
                    letter-spacing: 0em;
                    text-align: left;
                    text-transform: uppercase;

                    @media (max-width: $breakpoint-md) {
                        text-align: center;
                    }

                    @media (max-width: $breakpoint-xs) {
                        padding-left: 15px;
                        padding-right: 15px;
                    }
                }

                .description {
                    line-height: 28px;
                    text-align: left;

                    @media (max-width: $breakpoint-md) {
                        text-align: center;
                    }

                    @media (max-width: $breakpoint-xs) {
                        padding-left: 15px;
                        padding-right: 15px;
                    }
                }
            }
        }
    }
}
</style>
